module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD7SURBVEiJY2TABUL/MzMw/vVi+Pf/A8Ma1sNY1fh9lWLgYDdmYGS+ybCS8RY2JUw4LaASoLkFjAwMDAwMIb9tGZgYBahr9P93DKtYj0J8QHXDGRgYGBiFGOgRRCwMDAwMTrJ3N9HC8H0MDIwsDAwMDCyszLQwn4EB5gMWFtqFFNE+2Fgnx8DAwMDg3/SIDAtI8AGpvoX6AKaJkYGB4T+SNDofWS2R6hlIjGRSEwS9goh4Vy3MEcUQS575jpAFTJCggwUhNhqfK3HpRwQRMx6TIXT2ok845XHrx0hF1AeDJydTZgGtfcDKynzoPwODHTUNZmRgOERN8wYOAAD7ozPRvGaJ2wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sh-sj.png
// module id = R3kj
// module chunks = 0